import axios from "axios";
import { API_BASE_URL } from "../../config";
import { authHeaders } from "../utils/session";

const getAuthHeaders = () => ({
  ...authHeaders(),
});

/**
 * Fetch all CMS menus with nested sub-menus
 */
export const fetchCmsMenus = async () => {
  const response = await axios.get(`${API_BASE_URL}/cms-menus`, {
    headers: getAuthHeaders(),
  });

  const data = response?.data?.data;
  if (!Array.isArray(data)) {
    throw new Error(response?.data?.message || "Failed to fetch CMS menus");
  }

  return data;
};
